import { find, get, isEmpty, toLower } from "lodash";
import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import { Field, Formik } from "formik";
import * as Yup from "yup";
import { SearchableList, LoaderWrapper } from "..";
import { useDeepEffect, useRequest } from "../../abstracts";
import { GetRecordKeepers, SaveRecordKeepers } from "../../services";
import { FieldInput } from "..";
import { errors, tranformListToDropdownValues } from "../../utils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { useCallback } from "react";

const RecordKeeperDropdown = ({
  data,
  onSelect,
  value,
  setData,
  setFieldValueOuter,
}) => {
  const [newrecordkeeper, setnewrecordkeeper] = useState();
  const loading = false;
  const location = useLocation();
  const [request, setRequest] = useState({
    method: GetRecordKeepers,
  });

  const alreadyExist = (val) => {
    const temp = data.map((item) => {
      if (toLower(item.label) === toLower(val)) return true;
      else return false;
    });
    return temp.includes(true);
  };
  const schema = Yup.object().shape({
    recordKeeperId: Yup.string()
      .required(errors.RecordKeeperName.required)
      .test(
        "newrecordkeeper",
        errors.RecordKeeperName.alreadyExist,
        (val) => !alreadyExist(val)
      ),
  });
  const keyDown = (e) => {
    if (e.keyCode == 32) {
      e.preventDefault();
      e.target.value += " ";
    }
  };
  useDeepEffect(
    () => {
      if (!loading) {
        if (newrecordkeeper) {
          const filteredValue = find(
            data,
            (item) => toLower(item.name) === toLower(newrecordkeeper)
          );
          onSelect(
            get(filteredValue, "id", ""),
            get(filteredValue, "name", "")
          );
        }
        setData(tranformListToDropdownValues(data || [], "name", "id"));
      }
    },
    [loading],
    true
  );
  const onFormSubmit = (values) => {
    SaveRecordKeepers({ Name: values["recordKeeperId"] }).then((response) => {
      GetRecordKeepers().then((res) => {
        setData(
          res.map((option) => ({
            value: option.id,
            label: option.name,
          }))
        );
        setFieldValueOuter("recordKeeperId", res[res.length - 1].id);
        setFieldValueOuter("recordKeeper", res[res.length - 1].name);
      });
    });
  };

  return (
    <>
      <LoaderWrapper isLoading={loading} loaderText="">
        <Formik
          initialValues={{
            newrecordkeeper: "",
          }}
          validationSchema={schema}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize
          onSubmit={onFormSubmit}
        >
          {({ handleChange, handleSubmit, values }) => {
            return (
              <>
                <div className="dropdside-custom-dropdown">
                  <div>
                    <SearchableList
                      height="200px"
                      label="Select the Recordkeeper name"
                      options={data}
                      onSelect={onSelect}
                      selectedValue={value}
                    />
                  </div>
                  <div className="line-separator"></div>
                  <Form autoComplete="off" onSubmit={handleSubmit}>
                    <div className="emppopvalid">
                      <Field
                        label="Add new RecordKeeper :"
                        name={"recordKeeperId"}
                        type="text"
                        maxLength={30}
                        className="add-classification-field"
                        value={values["recordKeeperId"]}
                        onChange={handleChange}
                        autoComplete="nope"
                        component={FieldInput}
                        placeholder={"Record keeper"}
                        onKeyDown={keyDown}
                      />
                    </div>
                    <Form.Group>
                      <Button type="Submit">Add</Button>
                    </Form.Group>
                  </Form>
                </div>
              </>
            );
          }}
        </Formik>
      </LoaderWrapper>
    </>
  );
};

export default RecordKeeperDropdown;
